import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { putItems, getItems } from "../../redux/actions/actionItem";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import {
  customStyles,
  customStylesItems,
} from "../../Constantes/constantesEstilos";

export default function ItemModify() {
  const initialForm = {
    name: "",
    description: "",
    stock: "",
    stockTotal: "",
    value: "",
  };

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const items = useSelector((state) => state.items.allItems);
  const [form, setForm] = useState(initialForm);
  const [itemFind, setItemFind] = useState("");

  useEffect(() => {
    dispatch(getItems());
  }, [dispatch]);

  const handleItem = (e) => {
    console.log(e);
    setItemFind(e.value);
    setForm({
      ...form,
      id: e.value,
    });
  };

  const handleChange = (e) => {
    const { value } = e.target;
    setForm({
      ...form,
      [e.target.name]: value,
    });
  };

  const itemFilter = items.find((e) => e._id === itemFind);
  console.log(itemFilter);

  const handleSubmit = () => {
    dispatch(putItems(form));
    setForm({
      id: "",
      name: "",
      description: "",
      stock: "",
      stockTotal: "",
      value: "",
    });

    setTimeout(() => {
      navigate("/items/listado")
  }, 300);
  };

  return (
    <div className="min-w-full max-w-screen-2xl bg-gray-900">
      <div className="m-8 text-orange-500 font-bold">
      <div>
        <p className="text-xl pb-8 underline">Actualizacion de Articulo</p>
      </div>
      <div>
        <div className="w-1/3 text-[10pt]">
          <label className="">
            Seleccione articulo
          </label>
          <Select
            options={items.map((e) => ({
              label: [e.idItem, " - ", e.name, " - ", e.description],
              value: e._id,
            }))}
            placeholder="Articulos"
            styles={customStylesItems}
            onChange={handleItem}
          />
        </div>
        <div>
          <div className="pt-4">
            {itemFilter !== undefined ? (
              <div className="flex flex-col">
                <div className="flex flex-row font-semibold h-12 border-b border-black pt-2"><p className="text-[12pt] w-28">Id: </p><p>{itemFilter.idItem}</p></div>
                
                <div className="flex flex-row border-b border-black h-12 pt-2">
                  <div className="flex flex-row font-semibold h-12 w-52"><p className="text-[12pt] w-28">Nombre: </p><p>{itemFilter.name}</p></div>
                  <div className="flex flex-row font-semibold h-8">
                  <label className="text-[12pt] w-28">Nuevo Nombre</label>
                  <input
                    className="w-64 text-center  bg-slate-700"
                    type="text"
                    name="name"
                    onChange={handleChange}
                    value={form.name}
                  />
                </div>
                </div>
                <div className="flex flex-row border-b border-black h-12 pt-2">
                <div className="flex flex-row font-semibold h-12 w-52"><p className="text-[12pt] w-28">Descripcion: </p><p>{itemFilter.description}</p></div>
                <div className="flex flex-row font-semibold h-8">
                  <label className="text-[12pt] w-28">Nueva Descripcion</label>
                  <input
                    className="w-64 text-center  bg-slate-700"
                    type="text"
                    name="description"
                    onChange={handleChange}
                    value={form.description}
                  />
                </div>
                </div>

                <div className="flex flex-row border-b border-black h-12 pt-2">                
                <div className="flex flex-row font-semibold h-8 w-52"><p className="text-[12pt] w-28">Stock: </p><p>{itemFilter.stock}</p></div>
                <div className="flex flex-row font-semibold h-8">
                  <label className="text-[12pt] w-28">Stock nuevo</label>
                  <input
                    className="w-64 text-center bg-slate-700"
                    type="number"
                    name="stock"
                    onChange={handleChange}
                    value={form.stock}
                  />
                </div>
                </div>

                <div className="flex flex-row border-b border-black h-12 pt-2">
                <div className="flex flex-row font-semibold h-8 w-52"><p className="text-[12pt] w-28">Stock Total: </p><p>{itemFilter.stockTotal}</p></div>
                <div className="flex flex-row font-semibold h-8">
                  <label className="text-[12pt] w-28">StockTotal</label>
                  <input
                    className="w-64 text-center bg-slate-700"
                    type="number"
                    name="stockTotal"
                    onChange={handleChange}
                    value={(form.stockTotal = form.stock)}
                  />
                </div>
                </div>

                <div className="flex flex-row border-b border-black h-12 pt-2">
                <div className="flex flex-row font-semibold h-8 w-52"><p className="text-[12pt] w-28">Valor: </p><p>{itemFilter.value}</p></div>
                <div className="flex flex-row font-semibold h-8">
                  <label className="text-[12pt] w-28">Valor</label>
                  <input
                    className="w-64 text-center bg-slate-700"
                    type="number"
                    name="value"
                    onChange={handleChange}
                    value={form.value}
                  />
                </div>
                </div>
              </div>
            ) : (
              <div>No hay articulo Seleccionado</div>
            )}
          </div>          
        </div>
        <div>          
          <button className="mt-12 p-4 rounded bg-sky-500 text-white hover:bg-red-600" onClick={handleSubmit}>Guardar</button>
        </div>
      </div>
      </div>
    </div>
  );
}
